import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/www-roomvia-ai/app/ClientLayout.tsx");
;
import(/* webpackMode: "eager" */ "/opt/www-roomvia-ai/app/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/www-roomvia-ai/node_modules/.pnpm/next@15.2.8_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/www-roomvia-ai/node_modules/.pnpm/next@15.2.8_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
